<div style="margin-top: 20px">
    <div class="row">
        <div class="col-12">
            <wj-flex-grid
                id="gridHoursVariance"
                #gridHoursVariance
                appAutoSize
                [padding]="73"
                (initialized)="hoursVarianceGrid.initialize(gridHoursVariance)"
                [itemsSource]="hoursVarianceGrid.view"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Vehicle'" [binding]="'vehicle'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'WebApps Date'" [binding]="'webAppsDate'" [width]="'*'"> </wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Vista Date'" [binding]="'vistaDate'" [width]="'*'"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'WebApps Hours'"
                    [binding]="'webAppsHours'"
                    [width]="'*'"
                    [format]="'N2'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Vista Hours'" [binding]="'vistaHours'" [width]="'*'" [format]="'N2'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Variance'" [binding]="'variance'" [width]="'*'" [format]="'N2'"></wj-flex-grid-column>
            </wj-flex-grid>
            <grid-selection-calculation [grid]="gridHoursVariance"></grid-selection-calculation>
        </div>
    </div>
</div>
